import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function RFQ() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [purchaseRequests, setPurchaseRequests] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [editId, setEditId] = useState(null);
    const [vendorRows, setVendorRows] = useState([{
        supplier: "", quotation_received: false
    }]);
    const [formData, setFormData] = useState({
        rfq_no: "", purchase_request: "", rfq_date: "", closing_date: "", remarks: ""
    });
    useEffect(() => {
        getRFQ();
        getPurchaseRequests();
        getSuppliers();
    }, []);
    const getRFQ = () => {
        setLoading(true);
        axios.get(baseUrl + "rfq/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getPurchaseRequests = () => {
        axios.get(baseUrl + "purchase-request/")
            .then((res) => {
                setPurchaseRequests(res.data);
            });
    };
    const getSuppliers = () => {
        axios.get(baseUrl + "user-profile/")
            .then((res) => {
                setSuppliers(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };
    const handleVendorChange = (index, e) => {
        const {name, value, type, checked} = e.target;
        const data = [...vendorRows];
        data[index][name] = type === "checkbox" ? checked : value;
        setVendorRows(data);
    };
    const addVendor = () => {
        setVendorRows([...vendorRows, {
            supplier: "", quotation_received: false
        }]);
    };
    const removeVendor = (index) => {
        const data = [...vendorRows];
        data.splice(index, 1);
        setVendorRows(data);
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            rfq_no: "", purchase_request: "", rfq_date: "", closing_date: "", remarks: ""
        });
        setVendorRows([{
            supplier: "", quotation_received: false
        }]);
    };
    const editData = async (row) => {

    setEditId(row.id);

    setFormData({
        rfq_no: row.rfq_no,
        purchase_request: row.purchase_request.id,
        rfq_date: row.rfq_date,
        closing_date: row.closing_date,
        remarks: row.remarks
    });

    const res = await axios.get(
        baseUrl + `rfq-vendor/${row.id}/`
    );

    setVendorRows(
        res.data.map(v => ({
            id: v.id,
            supplier: v.supplier.id,
            quotation_received: v.quotation_received
        }))
    );

};
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete RFQ?", icon: "warning", showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`update-rfq/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "", "success");
                        getRFQ();
                    });
            }
        });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const headerData = new FormData();
            headerData.append("rfq_no", formData.rfq_no);
            headerData.append("purchase_request", formData.purchase_request);
            headerData.append("rfq_date", formData.rfq_date);
            headerData.append("closing_date", formData.closing_date);
            headerData.append("remarks", formData.remarks);
            headerData.append("addedby", userName);
            headerData.append("ip_add", ipAddress);
            let rfqId = editId;
            if (editId === null) {
                const res = await axios.post(baseUrl + "rfq/", headerData);
                rfqId = res.data.id;
            } else {
                await axios.put(baseUrl + `update-rfq/${editId}/`, headerData);
            }
            for (const vendor of vendorRows) {
                const vendorData = new FormData();
                vendorData.append("rfq", rfqId);
                vendorData.append("supplier", vendor.supplier);
                vendorData.append("quotation_received", vendor.quotation_received);
                if (vendor.id) {
                    await axios.put(baseUrl + `update-rfq-vendor/${vendor.id}/`, vendorData);
                } else {
                    await axios.post(baseUrl + "rfq-vendor/", vendorData);
                }
            }
            Swal.fire("Success", editId === null ? "RFQ Saved Successfully" : "RFQ Updated Successfully", "success");
            clearForm();
            getRFQ();
        } catch (err) {
            Swal.fire("Error", "Unable to Save RFQ", "error");
        }
        setLoading(false);
    };
    const columns = [{
        field: "rfq_no", headerName: "RFQ No", width: 170
    }, {
        field: "purchase_request",
        headerName: "Purchase Request",
        width: 180,
        renderCell: (params) => (params.row.purchase_request?.request_no)
    }, {
        field: "rfq_date", headerName: "RFQ Date", width: 130
    }, {
        field: "closing_date", headerName: "Closing Date", width: 140
    }, {
        field: "remarks", headerName: "Remarks", width: 280
    }, {
        field: "action", headerName: "Action", width: 180, sortable: false, renderCell: (params) => (<>

            <button
                className="btn btn-success btn-sm me-2"
                onClick={() => editData(params.row)}
            >
                Edit
            </button>

            <button
                className="btn btn-danger btn-sm"
                onClick={() => deleteData(params.row.id)}
            >
                Delete
            </button>

        </>)
    }];
    return (<div className="container-fluid mt-3">

        <div className="card shadow">

            <div className="card-header bg-success text-white">

                <h5 className="mb-0">

                    Request For Quotation (RFQ)

                </h5>

            </div>

            <div className="card-body">

                <form onSubmit={saveData}>

                    <div className="row">

                        <div className="col-md-3 mb-3">

                            <label>RFQ No</label>

                            <input
                                type="text"
                                className="form-control"
                                name="rfq_no"
                                value={formData.rfq_no}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Purchase Request</label>

                            <select
                                className="form-control"
                                name="purchase_request"
                                value={formData.purchase_request}
                                onChange={handleChange}
                                required
                            >

                                <option value="">
                                    Select Purchase Request
                                </option>

                                {purchaseRequests.map((item) => (<option
                                    key={item.id}
                                    value={item.id}
                                >
                                    {item.request_no}
                                </option>))}

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>RFQ Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="rfq_date"
                                value={formData.rfq_date}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Closing Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="closing_date"
                                value={formData.closing_date}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        <div className="col-md-12 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="3"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>
                        <hr/>

                        <div className="col-md-12">

                            <div className="d-flex justify-content-between align-items-center mb-3">

                                <h5>
                                    RFQ Suppliers
                                </h5>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={addVendor}
                                >
                                    + Add Supplier
                                </button>

                            </div>


                            <div className="table-responsive">

                                <table className="table-erp-modern">

                                    <thead className="table-success">

                                    <tr>

                                        <th width="60%">
                                            Supplier
                                        </th>

                                        <th width="20%">
                                            Quotation Received
                                        </th>

                                        <th width="20%">
                                            Action
                                        </th>

                                    </tr>

                                    </thead>


                                    <tbody>

                                    {vendorRows.map((row, index) => (<tr key={index}>


                                        <td>

                                            <select
                                                className="form-control"
                                                name="supplier"
                                                value={row.supplier}
                                                onChange={(e) => handleVendorChange(index, e)}
                                                required
                                            >

                                                <option value="">
                                                    Select Supplier
                                                </option>


                                                {suppliers.map((supplier) => (<option
                                                    key={supplier.id}
                                                    value={supplier.id}
                                                >

                                                    {supplier.name || supplier.username}

                                                </option>))}


                                            </select>


                                        </td>


                                        <td className="text-center">


                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                name="quotation_received"
                                                checked={row.quotation_received}
                                                onChange={(e) => handleVendorChange(index, e)}
                                            />


                                        </td>


                                        <td className="text-center">


                                            {vendorRows.length > 1 && (<button

                                                type="button"

                                                className="btn btn-danger btn-sm"

                                                onClick={() => removeVendor(index)}

                                            >

                                                Remove

                                            </button>)}


                                        </td>


                                    </tr>))}


                                    </tbody>


                                </table>


                            </div>


                        </div>


                        <div className="col-md-12 mt-3">


                            <button

                                type="submit"

                                className="btn btn-success me-2"

                                disabled={loading}

                            >

                                {editId === null ? "Save RFQ" : "Update RFQ"}


                            </button>


                            <button

                                type="button"

                                className="btn btn-secondary"

                                onClick={clearForm}

                            >

                                Clear

                            </button>


                        </div>


                    </div>


                </form>


            </div>


        </div>
        <div className="card shadow mt-3">

            <div className="card-header bg-primary text-white">

                <h5 className="mb-0">

                    RFQ List

                </h5>

            </div>


            <div className="card-body">


                <div
                    style={{
                        height: 600, width: "100%"
                    }}
                >


                    <ERPDataGrid

                        rows={rows}

                        columns={columns}

                        loading={loading}

                        getRowId={(row) => row.id}

                        pageSizeOptions={[10, 25, 50, 100]}

                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}


                        disableRowSelectionOnClick

                    />


                </div>


            </div>


        </div>


    </div>);
}
export default RFQ;